import FormBase from "../../forms/FormBase";
import FormFieldBase from "../../forms/FormFieldBase";
import LoginForm from "../../forms/autenticate/LoginForm";

interface IUpdateForm {
    type: "UPDATE_FORM";
    payload: {
        form: FormBase;
        name: string;
        value: any;
    };
}

interface IValidateForm {
    type: "VALIDATE_FORM",
    payload: {
        form: FormBase;
    }
}

export type Actions = IUpdateForm | IValidateForm;

export interface ILoginFormState {
    LoginForm: LoginForm;
}

export const initialState: ILoginFormState = {
    LoginForm: LoginForm.NewInstance()
};

export const reducer = (state: ILoginFormState, action: Actions) => {
    
    switch (action.type) {
        case "UPDATE_FORM": {
            const { form, name, value } = action.payload;

            (form.GetFieldByName(name) as FormFieldBase).Value = value;
            (form.GetFieldByName(name) as FormFieldBase).InputChange(value);
            (form.GetFieldByName(name) as FormFieldBase).ValidateField();

            return { ...state };
        }
        case "VALIDATE_FORM": {
            const { form } = action.payload;

            (form as LoginForm).ValidateForm();

            return { ...state };
        }
        default:
            return { ...state };
    }
}